import * as React from 'react';
import Page from '../Page';
import DataSummary939 from './CourtReporting939DataSummaryCore';
import { UserRoleEnum } from '../../redux/UserSlice';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';




const CourtReporting939SummaryA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <Page>
                <DataSummary939 userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser} dataSection="Summary" />
            </Page>
        </React.Fragment>
    );
}

export default CourtReporting939SummaryA;